require.context('../images', true)
require("@rails/ujs").start()
require("turbolinks").start()
require('jquery')
require('jquery-bridget')
require("../javascript/site/plugins")
require("../javascript/site")